/* eslint-disable react/prop-types */
import React from "react"
import {
  ListItem,
  ListItemIcon,
  Checkbox,
  ListItemText,
} from "@material-ui/core"

const FilterItem = ({ onClick, filter }) => {
  return (
    <ListItem
      role={undefined}
      dense
      button
      onClick={() => onClick(filter.filter)}
    >
      <ListItemIcon>
        <Checkbox
          edge="start"
          checked={filter.checked || false}
          tabIndex={-1}
        />
      </ListItemIcon>
      <ListItemText primary={filter.label} secondary={filter.description} />
    </ListItem>
  )
}

export default FilterItem
